import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  newResultType: {
    firm: 1,
    isInactive: false,
    sort: 0,
    year: null,
    vehicleMake: null,
    vehicleMakeName: '',
    driveType: null,
    driveTypeName: '',
    testdriveResultType: null,
    testdriveResultTypeName: '',
    testdriveResultCode: ''
  },
  newadasmatrix: {
    id: null,
    adasChecklistMatrix: null,
    matrixItem: null,
    isInactive: false,
    isRemove: false,
    sort: 0,
    items: [],
    notice: '',
    hints: '',
    keywords: ''
  },
  newadasmakematrix: {
    id: null,
    adasChecklistMatrixVehicle: null,
    adasChecklistMatrix: null,
    vehicleMake: null,
    vehicleModel: null,
    yearStart: null,
    yearEnd: null,
    system: null,
    location: null,
    isRR: false,
    isRI: false,
    calibrationType: null,
    url: null,
    isInactive: false,
    sort: null,
    source: null,
    locations: [],
    systems: [],
    static: [],
    dynamic: [],
    triggerNotice: null,
    triggerNoticeText: null
  },
  newadasmatrixinfolookup: {
    id: null,
    adasChecklistMatrixInfoLookup: null,
    adasChecklistMatrix: null,
    vehicleMake: null,
    yearStart: null,
    yearEnd: null,
    keywords: null,
    lookupType: null,
    url: null,
    isInactive: false,
    sort: null,
    source: null
  },
  recommendations: [],
  recommendation: null,
  criteriaChanged: false,
  step: 1,
  visitedStep: 1,
  translations: [],
  testdriveResultTypes: [],
  testdriveResultType: null,
  exclusions: [],
  adasmatrix: null,
  adasmatrices: JSON.parse(storage.session.getItem(types.SESSION_ADAS_MATRIX)) || [],
  decodedVin: [],
  decodedAltVin: [],
  adasmakematrices: [],
  adasmakematrix: null,
  adasmatrixinfolookups: [],
  adasmatrixinfolookup: null
})



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/state.js